import FormUploadComponentCol from './FormUploadComponentCol'

export default FormUploadComponentCol
